import React from "react";
import { Show } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import { Labeled, SimpleShowLayout, TextField, DateField, ReferenceField, FunctionField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { graduationRequests } from "api/graduationApi";
import { formatStudentOption } from "../utils";
import { InternshipSessionField } from "server/components/Fields/InternshipSessionInput";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowThesisDefense = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли на защита на дипломна работа"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Студент">
              <FunctionField render={formatStudentOption(true)} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Факултетен номер">
              <TextField source="studentInfo.facultyNumber" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Стажантска сесия">
              <InternshipSessionField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Държавен изпит">
              <ReferenceField
                source="stateExamId"
                reference={administrationRequests.getStateExamsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Статус">
              <ReferenceField
                source="status"
                reference={graduationRequests.getStateExamsStatusesSelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Създаден на">
              <DateField
                source="createdOn"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowThesisDefense;
